import ZapIcon from "@redotech/redo-icons/zap_filled.svg";
import { RedoIcon } from "@redotech/redo-web/arbiter-components/icon/redo-icon";
import { Tooltip as RedoTooltip } from "@redotech/redo-web/arbiter-components/tooltip/tooltip";
import { Flex } from "@redotech/redo-web/flex";
import { memo } from "react";

export const LearningIcon = memo(function LearningIcon() {
  return (
    <RedoTooltip title="This selection was made automatically based on previous orders that were fulfilled with similar products.">
      <Flex flexDirection="column" justify="center">
        <RedoIcon color="brand" Icon={ZapIcon} />
      </Flex>
    </RedoTooltip>
  );
});
